import * as screenfull from 'screenfull';

import {
  Inject,
  OnInit,
  Component,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { ISnPlayer } from '../../interfaces';
import { SnPlayerService } from '../../services/player.service';

@Component({
  selector: 'sn-player-fullscreen-control',
  templateUrl: './player-fullscreen.control.html',
  styleUrls: ['./player-fullscreen.control.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-player__fullscreen-control',
  },
})
export class SnPlayerFullscreenControl implements OnInit, OnDestroy {
  private _isFullScreen: boolean;

  @ViewChild('fullscreenButton', { static: true })
  private readonly _fullscreenButtonRef: ElementRef<HTMLElement>;

  @ViewChild('collapseButton', { static: true })
  private readonly _collapseButtonRef: ElementRef<HTMLElement>;

  private readonly _screenfull: screenfull.Screenfull = screenfull as screenfull.Screenfull;
  private readonly _fullscreenChangeHandlerFn = this._fullscreenChangeHandler.bind(this);

  constructor(
    private readonly _playerService: SnPlayerService,
    @Inject('SN_PLAYER') private readonly _player: ISnPlayer,
  ) {}

  public ngOnInit(): void {
    if (this._screenfull.isEnabled) {
      this._screenfull.onchange(this._fullscreenChangeHandlerFn);
    }
  }

  public ngOnDestroy(): void {
    if (this._screenfull.isEnabled) {
      this._screenfull.off('change', this._fullscreenChangeHandlerFn);
    }
  }

  public toggle(): void {
    if (this._isFullScreen) {
      this._playerService.fullscreenClose();
    } else {
      this._playerService.fullscreenOpen();
    }
    this._isFullScreen = !this._isFullScreen;
    this._player.changeFullscreen(true);
  }

  private _fullscreenChangeHandler(): void {
    if (this._screenfull.isFullscreen && this._isFullScreen) {
      this._collapseButtonRef.nativeElement.classList.remove('fs-d-none');
      this._fullscreenButtonRef.nativeElement.classList.add('fs-d-none');
    } else {
      if (this._isFullScreen) {
        this._isFullScreen = false;
        this._player.exitedFullscreen(false);
      }
      this._collapseButtonRef.nativeElement.classList.add('fs-d-none');
      this._fullscreenButtonRef.nativeElement.classList.remove('fs-d-none');
    }
  }
}
